import React, { useState } from "react"
import ModalError, { IModalError } from "../ModalError"
import { IModalCallback, TModalResponseType } from "./modalTypes"
import { modalReducerActions } from "../../../store/reducers/modalReducer"
import ModalInfo, { IModalInfo } from "../ModalInfo"
import useReduxDispatch from "../../../store/useReduxDispatch"

export type TAllModals = IModalInfo | IModalError

export type TAllModalsWithCallback = TAllModals & IModalCallback

interface ISingleModalProps {
    modal: TAllModalsWithCallback
}

const SingleModal = ({ modal }: ISingleModalProps) => {
    const { callback, ...modalWithoutCallback } = modal
    const [modalResponse, setModalResponse] = useState<[TModalResponseType, any | undefined]>()
    const dispatch = useReduxDispatch()

    const controlProps = {
        isOpen: !modalResponse,
        callback: (res: TModalResponseType, data?: any) => {
            setModalResponse([res, data])
        },
        onClosed: () => {
            dispatch(modalReducerActions.removeModal(modal))
            callback(modalResponse ? modalResponse[0] : "ignored", modalResponse ? modalResponse[1] : undefined)
        },
    }

    switch (modalWithoutCallback.type) {
        case "info":
            return <ModalInfo {...modalWithoutCallback} {...controlProps} />
        case "error":
            return <ModalError {...modalWithoutCallback} {...controlProps} />
        default:
            return null
    }
}

export default SingleModal
